<template>
    <div class="share-notes" :class="{ 'dark-theme': shouldUseDarkTheme }"
        :data-theme="shouldUseDarkTheme ? 'dark' : 'light'">
        <div class="share-progress-container" v-show="notes.iscreating == -1">
            <h1>Loading...</h1>
        </div>
        <div class="share-progress-container" v-show="notes.iscreating == 0">
            <img class="share-loadingimg" :src="loading_img" alt="" />
            <h1>We're Creating Your Notes...</h1>
            <p class="share-progress-text">{{ progress }}% Completed</p>
            <div class="share-progress-bar">
                <div class="share-progress" :style="{ width: progress + '%' }"></div>
            </div>
            <p v-if="noteobj.filetype == 'audio'" class="share-uploadtishi"><i class="el-icon-info"></i>Estimated
                processing
                time:
                5-30 minutes based on audio length. Please wait
                patiently. Do not refresh or close the page.</p>
        </div>
        <div class="share-progress-container" v-show="notes.iscreating == 3">
            <img class="share-loadingimg" :src="error_img" alt="" />
            <h1 v-if="notes.taskcount <= 1">Note generation failed, please try again later.</h1>
            <h1 v-else>It seems there's a problem with the file. <br>Please try a new one.</h1>
            <div class="share-notebtnbox">
                <button v-if="notes.taskcount <= 1" class="share-resert" @click="tryagain">Try again</button>
                <button v-if="noteobj.filetype == 'audio'" class="share-save" @click="saveaudio">Save audio
                    locally</button>
                <span v-if="false"> <i class="el-icon-warning"></i>The recording file will be deleted in
                    24 hours. Please save it to your local device immediately.</span>
            </div>
        </div>
        <div class="share-progress-container" v-show="notes.iscreating == 4">
            <img class="share-loadingimg" :src="error_img" alt="" />
            <h1>The recording file has been automatically <br>deleted as it has exceeded the 24-hour saving period.</h1>
        </div>
        <div v-show="notes.iscreating == 1">
            <!-- 修改移动端复制按钮，只保留复制markdown功能 -->
            <div class="share-mobile-action-buttons" v-if="isMobile && noteobj.filetype != 'record'">
                <button class="share-mobile-action-btn" @click="copymarkdown()" title="Copy as Markdown">
                    <i class="el-icon-document"></i>
                </button>
            </div>
            <div class="share-mobile-action-buttons" v-if="isMobile && noteobj.filetype == 'record'">
                <button class="share-mobile-action-btn" @click="copytranscript('part')" title="Copy as Text">
                    <i class="el-icon-document"></i>
                </button>
            </div>

            <div class="share-note-actions">
                <el-dropdown class="share-export"
                    v-if="!isMobile && (noteobj.filetype != 'record' || (noteobj?.filetype == 'record' && !noteobj?.live_transcript?.text_objs))"
                    @command="handleCommand">
                    <span class="el-dropdown-link">
                        Copy as<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="copymarkdown" icon="el-icon-c-scale-to-original">Copy as
                            Markdown</el-dropdown-item>
                        <el-dropdown-item command="copytext" icon="el-icon-tickets">Copy as
                            TXT</el-dropdown-item>
                        <el-dropdown-item command="downloadaspdf" icon="el-icon-download">Download as
                            PDF</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>

            <div class="share-youtubebox" v-if="noteobj.filetype == 'youtube' && !showTranslate">
                <YoutubePlayer v-if="noteobj?.filelinkpath" :url="noteobj?.filelinkpath" />
            </div>
            <div ref="contentToDownload" class="share-markdown-content"
                v-if="notes.mk_notes && (noteobj.filetype != 'record' || (noteobj?.filetype == 'record' && !noteobj?.live_transcript?.text_objs))"
                v-html="renderedNotes"></div>
            <div class="share-copyasbox"
                v-if="!isMobile && noteobj.filetype == 'record' && noteobj?.live_transcript?.text_objs">
                <div class="share-right">
                    <el-dropdown class="share-copyas" @command="handleCommand">
                        <span class="el-dropdown-link">
                            Copy as<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="copymarkdown-lr" icon="el-icon-c-scale-to-original">Copy as
                                Markdown</el-dropdown-item>
                            <el-dropdown-item command="copytext-lr" icon="el-icon-tickets">Copy as
                                TXT</el-dropdown-item>
                            <el-dropdown-item command="downloadaspdf-lr" icon="el-icon-download">Download as
                                PDF</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <div class="share-alltextbox" v-if="noteobj.filetype == 'record' && noteobj?.live_transcript?.text_objs">
                <div class="share-left_text share-right_tb" ref="right_tb">
                    <div class="share-textbox" v-for="(textobj, i) in transcript?.part_objs" :key="i">
                        <h5>{{ textobj.time }}</h5>
                        <div class="share-yuantext share-markdown-content-noh" v-html="textobj.mk_notes"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MarkdownIt from "markdown-it";
import hljs from "highlight.js";
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'
import YoutubePlayer from '@/components/YoutubePlayer.vue'
export default {
    components: {
        YoutubePlayer
    },
    props: {
        noteobj: {
            type: Object,
            default: () => ({}),
        },
    },
    watch: {
        noteobj: {
            handler(newobject) {
                this.iscreating = this.noteobj.status;

                this.notes["iscreating"] = newobject.status;
                this.notes["taskcount"] = newobject.task_count;
                this.notes["mk_notes"] = newobject.note_text;
                if (newobject.filetype == 'record') {
                    this.transcript = newobject.live_transcript;
                    this.transcript?.part_objs.forEach((item) => {
                        item['mk_notes'] = this.md.render(item.notes);
                    });
                }
                const translatingNote = JSON.parse(this.$cookies.get('translating_note') || '{}')
                if ((newobject?.note_translate || translatingNote.noteid == newobject.noteid) && this.notes.iscreating == 1) {
                    this.toggleTranslate(true)
                }

                this.$nextTick(() => {
                    this.initResizer();
                });

                if (newobject.filetype !== 'record' && newobject.filetype) {
                    this.toggleTranslate(true);
                }
            },
            deep: true,
        },
    },
    mounted() {
        this.notes["iscreating"] = this.noteobj.status;
        this.notes["mk_notes"] = this.noteobj.note_text;
        this.notes["type"] = this.noteobj.progress;
        this.notes["taskcount"] = this.noteobj.task_count;
        if (this.noteobj.filetype == 'record') {
            this.transcript = this.noteobj.live_transcript;
            this.transcript?.part_objs.forEach((item) => {
                item['mk_notes'] = this.md.render(item.notes);
            });
        }
        this.$nextTick(() => {
            if (this.noteobj.filetype === 'record') {
                this.initResizer();
            }
        });
        this.setprogress();

        setTimeout(() => {
            if (this.noteobj.filetype !== 'record' && this.noteobj.filetype) {
                this.toggleTranslate(true);
            }
        }, 1000);

        // 检测是否为移动端
        this.checkIfMobile();
        window.addEventListener('resize', this.checkIfMobile);

        // 初始化主题
        this.currentTheme = localStorage.getItem('easynote-theme-preference') || 'light';
    },
    computed: {
        shouldUseDarkTheme() {
            // 优先使用当前组件的主题状态，然后从localStorage读取
            return this.currentTheme === 'dark' || localStorage.getItem('easynote-theme-preference') === 'dark';
        },
        showTranslateButton() {
            return this.noteobj?.filetype !== 'record'
        },
        renderedNotes() {
            if (!this.notes || typeof this.notes.mk_notes !== "string") {
                return "";
            }
            return this.md.render(this.notes.mk_notes);
        },
    },
    data() {
        return {
            loading_img: require("@/assets/images/noteindex/loading_img1.gif"),
            error_img: require("@/assets/images/noteindex/error_note.png"),
            md: new MarkdownIt({
                html: true,
                linkify: true,
                typographer: true,
                highlight: function (str, lang) {
                    if (lang && hljs.getLanguage(lang)) {
                        try {
                            return hljs.highlight(lang, str).value;
                        } catch (__) {
                            console.log("error", str, lang);
                        }
                    }
                    return "";
                },
            }),
            progress: 0,
            iscreating: -1,
            timer: null,
            timer_quick: null,
            transcript: {},
            notes: {
                mk_notes: "",
                iscreating: 0,
            },
            showTranslate: false,
            isMobile: false,
            copySuccess: false,
            // 添加主题状态数据
            currentTheme: 'light',
        };
    },
    methods: {
        toggleTranslate(isopen = null) {
            if (isopen == null) {
                this.showTranslate = !this.showTranslate;
            } else {
                this.showTranslate = isopen;
            }
            this.$emit("toggleTranslate", isopen);
        },
        handleCommand(command) {
            switch (command) {
                case "copymarkdown":
                    this.copymarkdown();
                    break;
                case "copymarkdown-lr":
                    this.copytranscript('part');
                    break;
                case "copytext":
                    this.copytext();
                    break;
                case "copytext-lr":
                    this.copytranscript('part-text');
                    break;
                case "copytext-rr":
                    this.copytranscript('text');
                    break;
                case "downloadaspdf":
                    this.downloadaspdf('contentToDownload');
                    break;
                case "downloadaspdf-rr":
                    this.downloadaspdf('left_text');
                    break;
                case "downloadaspdf-lr":
                    this.downloadaspdf('right_tb');
                    break;
                case "noteshare":
                    this.noteshare();
                    break;
                // 支持新的命令格式
                case "copyMarkdown":
                    this.copymarkdown();
                    break;
                case "copyText":
                    this.copytext();
                    break;
                case "copyPDF":
                    this.downloadaspdf('contentToDownload');
                    break;
                default:
                    break;
            }
        },
        copytranscript(what) {
            let copyContent = '';
            let htmlContent = '';
            switch (what) {
                case 'part':
                    copyContent = this.transcript?.part_objs
                        .map((item) => item.notes)
                        .join('\n');
                    break;
                case 'part-text':
                    htmlContent = this.transcript?.part_objs
                        .map((item) => item.mk_notes)
                        .join('');
                    console.log("htmlContent", htmlContent);
                    copyContent = this.htmlToText(htmlContent);
                    break;
                case 'text':
                    copyContent = this.transcript?.text_objs
                        .map((item) => item.text)
                        .join('\n');
                    break;
            }

            this.copyToClipboard(copyContent);
            this.$message({ message: "Text copied to clipboard", type: "success" });
        },
        copymarkdown() {
            const markdownContent = this.notes.mk_notes;
            this.copyToClipboard(markdownContent);
            this.$message({ message: "Markdown copied to clipboard", type: "success" });
            this.showCopiedEffect(); // 添加复制成功效果
        },
        copytext() {
            const textContent = this.htmlToText(this.renderedNotes);
            this.copyToClipboard(textContent);
            this.$message({ message: "Text copied to clipboard", type: "success" });
        },
        downloadaspdf(resobj) {
            this.printPdf(resobj);
        },
        async printPdf(resobj) {
            try {
                // 获取打印容器
                const printContainer = this.$refs[resobj];
                if (!printContainer || !printContainer.innerHTML.trim()) {
                    throw new Error('No content to print');
                }

                // 创建一个隐藏的 iframe
                const iframe = document.createElement('iframe');
                iframe.style.position = 'absolute';
                iframe.style.top = '-9999px';
                iframe.style.left = '-9999px';
                document.body.appendChild(iframe);

                // 将打印容器的内容复制到 iframe 中
                const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
                iframeDocument.open();
                iframeDocument.write(`
        <html>
          <head>
            <title>打印内容</title>
            <style>
              /* 添加你需要的样式 */
              body {
                font-family: Arial, sans-serif;
              }
              .print-container {
                padding: 20px;
              }
              ${this.getAdditionalStyles()} /* 获取额外需要的样式 */
            </style>
          </head>
          <body>
            ${printContainer.innerHTML}
          </body>
        </html>
      `);
                iframeDocument.close();

                // 等待 iframe 加载完成
                await new Promise((resolve) => {
                    iframe.onload = resolve;
                });

                // 等待一小段时间，确保所有内容都已渲染
                await new Promise((resolve) => setTimeout(resolve, 1000));

                // 调用浏览器的打印功能
                iframe.contentWindow.print();

                // 移除 iframe
                document.body.removeChild(iframe);
            } catch (error) {
                console.error('PDF打印失败:', error);
                alert('PDF打印失败，请稍后重试或联系支持人员。');
            }
        },
        // 获取额外需要的样式
        getAdditionalStyles() {
            // 这里可以返回任何额外需要的CSS
            return `
      /* 额外的CSS样式 */
      .custom-class {
        color: #333;
      }
    `;
        },
        async generateA4PaginatedPdf() {
            const content = this.$refs.contentToDownload;  // 获取需要下载的内容
            if (!content) {
                console.error('未找到需要下载的内容');
                return;
            }

            // 定义 A4 页面的尺寸（单位：像素，96DPI下）
            const A4_WIDTH = 595;
            const A4_HEIGHT = 842;
            const contentWidth = content.scrollWidth; // 容器的宽度
            const contentHeight = content.scrollHeight; // 容器的高度

            let pdf = new jsPDF({
                orientation: 'portrait',
                unit: 'pt',
                format: 'a4',
            });

            // 当前已经渲染的高度
            let renderedHeight = 0;

            while (renderedHeight < contentHeight) {
                // 使用 html2canvas 截取当前页面的内容
                const canvas = await html2canvas(content, {
                    width: contentWidth,  // 按照容器的宽度截取
                    height: Math.min(A4_HEIGHT, contentHeight - renderedHeight),  // 截取剩余高度，最多 A4 高度
                    x: 0,
                    y: renderedHeight,  // 从当前已经渲染的高度往下截取
                    scrollY: 0,  // 不让页面滚动
                });

                const imgData = canvas.toDataURL('image/jpeg', 1.0);

                // 计算图像在 PDF 中的宽高比例
                const imgWidth = A4_WIDTH;
                const imgHeight = (canvas.height * A4_WIDTH) / canvas.width;

                if (renderedHeight > 0) {
                    pdf.addPage();  // 添加新的一页
                }
                pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight);  // 添加图片到PDF

                renderedHeight += canvas.height;  // 更新渲染过的高度
            }

            // 下载生成的 PDF 文件
            pdf.save('generated_content.pdf');
        },
        async saveaudio() {

            const fileKey = this.noteobj.filepath;
            const filename = this.noteobj.filename;

            try {
                this.$message.info('Starting download...');

                // 获取下载链接
                const { data } = await this.$axios.post('/api/get_download_url/', {
                    fileKey: fileKey
                });

                if (!data.downloadUrl) {
                    throw new Error('Failed to get download URL');
                }

                // 使用 fetch 获取文件内容
                const response = await fetch(data.downloadUrl);
                if (!response.ok) {
                    throw new Error('Download failed');
                }

                // 获取文件 blob
                const blob = await response.blob();

                // 创建 blob URL
                const blobUrl = window.URL.createObjectURL(blob);

                // 创建下载链接
                const link = document.createElement('a');
                link.href = blobUrl;
                link.download = filename; // 设置下载文件名
                link.style.display = 'none';

                // 添加到文档并触发点击
                document.body.appendChild(link);
                link.click();

                // 清理
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);

                this.$message.success('Download completed!');

            } catch (error) {
                console.error('Download failed:', error);
                this.$message.error(`Download failed: ${error.message}`);
            }
        },
        tryagain() {
            this.$emit("tryagain");
        },
        noteshare() {
            console.log("noteshare", this.noteobj);
            const shareurl = window.location.origin + '/share?t=' + this.noteobj.notetoken;
            this.copyShareToClipboard(shareurl); // 复制到剪贴板
        },
        copyShareToClipboard(text) {
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text).then(() => {
                    this.$message({ message: "Share link copied to clipboard", type: "success" });
                }).catch((err) => {
                    console.error('Could not copy text: ', err);
                });
            } else {
                const textArea = document.createElement("textarea");
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                try {
                    document.execCommand('copy');
                    this.$message({ message: "Share link copied to clipboard", type: "success" });
                } catch (err) {
                    console.error('Could not copy text: ', err);
                }
                document.body.removeChild(textArea);
            }
        },
        downloadNotes() {
            // console.log("downloadNotes",this.noteobj);
            const textContent = this.htmlToText(this.renderedNotes);
            const blob = new Blob([textContent], { type: 'text/plain;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'notes.txt';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);
        },
        htmlToText(html) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;
            return tempDiv.textContent || tempDiv.innerText || '';
        },
        copyToClipboard(text) {
            if (navigator.clipboard && window.isSecureContext) {
                navigator.clipboard.writeText(text).then(() => {
                    // 复制成功,但不触发额外提示,只依靠上面的$message
                }).catch((err) => {
                    console.error('Could not copy text: ', err);
                });
            } else {
                const textArea = document.createElement("textarea");
                textArea.value = text;
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                try {
                    document.execCommand('copy');
                    // 复制成功,但不触发额外提示,只依靠上面的$message
                } catch (err) {
                    console.error('Could not copy text: ', err);
                }
                document.body.removeChild(textArea);
            }
        },
        setprogress() {
            clearInterval(this.timer);
            this.timer = setInterval(() => {
                const randomnums = Math.floor(Math.random() * 4) + 1;
                this.progress += randomnums;

                if (this.iscreating == 1) {
                    this.progress = 100;
                }
                if (this.progress >= 99) {
                    // 停止
                    this.progress = 99;
                    clearInterval(this.timer);
                }
            }, 3000);
        },
        initResizer() {
            const resizer = this.$refs.resizer;
            const leftPane = this.$refs.left_text;
            const rightPane = this.$refs.right_tb;
            const container = this.$el.querySelector('.share-alltextbox');

            if (!resizer || !leftPane || !rightPane || !container) {
                return;
            }

            let x = 0;
            let leftWidth = 0;

            const mouseDownHandler = (e) => {
                x = e.clientX;
                leftWidth = leftPane.getBoundingClientRect().width;
                document.addEventListener('mousemove', mouseMoveHandler);
                document.addEventListener('mouseup', mouseUpHandler);
                resizer.style.transition = 'none'; // 拖动时禁用过渡效果
            };

            const mouseMoveHandler = (e) => {
                const dx = e.clientX - x;
                const containerWidth = container.getBoundingClientRect().width;
                const minWidth = 100; // 最小宽度
                const maxWidth = containerWidth - 100; // 最大宽度

                let newLeftWidth = leftWidth + dx;
                newLeftWidth = Math.max(minWidth, Math.min(maxWidth, newLeftWidth));

                const newLeftWidthPercent = (newLeftWidth / containerWidth) * 100;
                leftPane.style.width = `${newLeftWidthPercent}%`;
            };

            const mouseUpHandler = () => {
                document.removeEventListener('mousemove', mouseMoveHandler);
                document.removeEventListener('mouseup', mouseUpHandler);
                resizer.style.transition = 'left 0.2s'; // 恢复过渡效果
                localStorage.setItem('leftPaneWidth', leftPane.style.width);
            };

            resizer.addEventListener('mousedown', mouseDownHandler);
        },
        checkIfMobile() {
            this.isMobile = window.innerWidth <= 768;
        },
        showCopiedEffect() {
            // 为移动端按钮添加一个短暂的复制成功效果
            if (this.isMobile) {
                const btn = document.querySelector('.share-mobile-action-btn');
                if (btn) {
                    btn.classList.add('share-copied');
                    setTimeout(() => {
                        btn.classList.remove('share-copied');
                    }, 800);
                }
            }
        },
        onThemeChange(isDark) {
            // 更新主题设置和组件状态
            this.currentTheme = isDark ? 'dark' : 'light';
            localStorage.setItem('easynote-theme-preference', this.currentTheme);
            // 强制重新渲染
            this.$forceUpdate();
        },
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkIfMobile);
    }
};
</script>

<style lang="less" scoped>
/* CSS变量 - 浅色主题 */
.share-notes {
    --text-color: #333333;
    --text-light: #666666;
    --border-color: #e6e8ed;
    --border-light: rgba(0, 0, 0, 0.06);
    --shadow-color: rgba(0, 0, 0, 0.08);
    --shadow-light: rgba(0, 0, 0, 0.04);
    --card-bg: rgba(245, 245, 245, 0.9);
    --button-bg: #f0f0f0;
    --button-text: #333;
    --button-hover-bg: #e0e0e0;
    --toggle-color: #333;
    --toggle-hover-bg: rgba(0, 0, 0, 0.1);
    --tooltip-bg: rgba(255, 255, 255, 0.9);
    --tooltip-text: #333;
    --progress-bg: #e0e0e0;
    --th-bg: #f0f2f5;
    --th-bg-enhanced: #f7faff;
    --table-bg: #fff;
    --row-hover: rgba(74, 123, 255, 0.04);
    --row-even: rgba(0, 0, 0, 0.01);
    --link-color: #4a7bff;
    --link-border: rgba(74, 123, 255, 0.3);
    --code-bg: rgba(27, 31, 35, 0.05);
    --code-bg-enhanced: rgba(74, 123, 255, 0.08);
    --code-color: #4a7bff;
    --pre-bg: #f6f8fa;
    --pre-bg-enhanced: #f8fafd;
    --pre-text: #333;
    --blockquote-bg: #f7faff;
    --blockquote-text: #4a5568;
    --blockquote-color: #6a737d;
    --primary-color: #4a7bff;
    --primary-light: rgba(74, 123, 255, 0.3);
    --primary-hover: #3955d1;
    --scroll-track: rgba(0, 0, 0, 0.02);
    --scroll-thumb: rgba(74, 123, 255, 0.2);
    --scroll-thumb-hover: rgba(74, 123, 255, 0.3);
    --note-bg: #fcfcfc;
    --note-border: rgba(0, 0, 0, 0.03);
    --main-text-color: #333;
    --h1-color: #222;
    --h2-color: #222;
    --h3-color: #333;
    --h4-color: #444;
    --p-color: #444;
    --strong-color: #222;
    --em-color: #555;
    --li-color: #444;
    --td-color: #34495e;
    --th-color: #2c3e50;
    
    color: var(--text-color);
    font-family: Arial, sans-serif;
    position: relative;
    flex: 1;
    max-height: calc(100vh - 130px);
    overflow: auto;
    transition: color 0.3s ease, background-color 0.3s ease;

    /* 深色主题的CSS变量 */
    &.dark-theme,
    &[data-theme="dark"] {
        --text-color: #e4e6ea;
        --text-light: #aaaaaa;
        --border-color: #3a3a3a;
        --border-light: rgba(255, 255, 255, 0.06);
        --shadow-color: rgba(0, 0, 0, 0.3);
        --shadow-light: rgba(0, 0, 0, 0.2);
        --card-bg: rgba(42, 42, 42, 0.9);
        --button-bg: #2c2c2c;
        --button-text: #ffffff;
        --button-hover-bg: #3c3c3c;
        --toggle-color: #fff;
        --toggle-hover-bg: rgba(255, 255, 255, 0.2);
        --tooltip-bg: rgba(60, 60, 60, 0.95);
        --tooltip-text: #f0f0f0;
        --progress-bg: #383838;
        --th-bg: #363636;
        --th-bg-enhanced: #2a2a2a;
        --table-bg: #1e1e1e;
        --row-hover: rgba(93, 111, 255, 0.08);
        --row-even: rgba(255, 255, 255, 0.02);
        --link-color: #58a6ff;
        --link-border: rgba(88, 166, 255, 0.3);
        --code-bg: rgba(240, 246, 252, 0.15);
        --code-bg-enhanced: rgba(93, 111, 255, 0.12);
        --code-color: #5d6fff;
        --pre-bg: #1e1e1e;
        --pre-bg-enhanced: #161b22;
        --pre-text: #e0e0e0;
        --blockquote-bg: rgba(93, 111, 255, 0.08);
        --blockquote-text: #c7ccd3;
        --blockquote-color: #c7ccd3;
        --primary-color: #5d6fff;
        --primary-light: rgba(93, 111, 255, 0.3);
        --primary-hover: #4a5ce0;
        --scroll-track: rgba(255, 255, 255, 0.05);
        --scroll-thumb: rgba(93, 111, 255, 0.3);
        --scroll-thumb-hover: rgba(93, 111, 255, 0.5);
        --note-bg: #1e1e1e;
        --note-border: rgba(255, 255, 255, 0.1);
        --main-text-color: #e4e6ea;
        --h1-color: #e4e6ea;
        --h2-color: #e4e6ea;
        --h3-color: #e4e6ea;
        --h4-color: #e4e6ea;
        --p-color: #e4e6ea;
        --strong-color: #ffffff;
        --em-color: #c7ccd3;
        --li-color: #e4e6ea;
        --td-color: #c7ccd3;
        --th-color: #ffffff;
    }

    .share-export {
        position: absolute;
        right: 2vw;
        top: 0px;
        background: var(--button-bg);
        color: var(--button-text);
        border: 1px solid var(--border-color);
        font-size: 16px;
        padding: 5px 12px;
        cursor: pointer;
        border-radius: 0.5vw;
        transition: all 0.3s ease;
        box-shadow: 0 2px 4px var(--shadow-color);

        &:hover {
            background: var(--button-hover-bg);
            transform: translateY(-1px);
        }
    }

    .share-translate-toggle {
        display: flex;
        align-items: center;
        cursor: pointer;
        color: var(--toggle-color);
        transition: all 0.3s ease;
        position: absolute;
        top: 2px;
        right: 5px;

        .share-tooltip {
            position: absolute;
            right: calc(100% - 10px);
            top: calc(50% + 50px);
            transform: translateY(-50%);
            background: var(--tooltip-bg);
            color: var(--tooltip-text);
            padding: 8px 12px;
            border-radius: 6px;
            font-size: 16px;
            white-space: nowrap;
            margin-right: 10px;
            box-shadow: 0 2px 12px var(--shadow-color);
            font-weight: 600;

            &::after {
                content: '';
                position: absolute;
                right: -10px;
                top: -8px;
                width: 0;
                height: 0;
                border-style: solid;
                border-width: 0 20px 10px 10px;
                border-color: transparent transparent var(--tooltip-bg) transparent;
                transform: rotate(-75deg);
            }
        }

        i {
            font-weight: 600;
            font-size: 27px;
        }
    }

    .share-translate-toggle:hover {
        background: var(--toggle-hover-bg);
    }

    .share-progress-container {
        color: var(--text-color);
        text-align: center;
        padding-top: 20vh;

        h1 {
            margin: 0;
            font-size: 2vw;
            margin-bottom: 10px;
        }

        .share-loadingimg {
            width: 6.5vw;
        }

        .share-uploadtishi {
            padding: 2vw 10%;

            i {
                color: rgb(212, 162, 97);
                margin-right: 0.5vw;
            }
        }

        .share-notebtnbox {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 3vw;

            button {
                border: none;
                width: 12vw;
                padding: 0.8vw 0;
                margin-bottom: 1vw;
                border-radius: 5px;
                font-size: 1vw;
                cursor: pointer;
                transition: all 0.3s ease;

                &:hover {
                    opacity: 0.8;
                }
            }

            .share-resert {
                background-color: rgb(22 163 74);
                color: #fff;
            }

            .share-save {
                background-color: #fff;
                color: #333;
            }

            span {
                color: red;
                font-size: 1vw;
            }
        }

        .share-progress-bar {
            background-color: var(--progress-bg);
            border-radius: 10px;
            height: 20px;
            margin: 1vw 2.2vw;
            overflow: hidden;

            .share-progress {
                background: var(--primary-color);
                height: 100%;
                transition: width 0.5s ease-in-out;
            }
        }

        .share-progress-text {
            font-size: 16px;
        }
    }

    .share-copyasbox {
        display: flex;
        padding: 0 0.5vw;

        .share-right {
            flex: 1;
            display: flex;
            flex-direction: row-reverse;
            align-items: center;
            justify-content: space-between;
            font-size: 22px;

            div {
                margin-left: 2vw;
            }
        }

        .share-copyas {
            background: var(--button-bg);
            color: var(--button-text);
            border: 1px solid var(--border-color);
            padding: 5px 12px;
            margin-right: 20px;
            cursor: pointer;
            display: inline-block;
            border-radius: 6px;
            transition: all 0.3s ease;
            box-shadow: 0 2px 4px var(--shadow-color);

            &:hover {
                background: var(--button-hover-bg);
                transform: translateY(-1px);
            }
        }
    }

    .share-alltextbox {
        border-radius: 5px;
        padding-top: 10px;

        .share-left_text {
            height: calc(100vh - 220px);
            overflow: auto;
            margin-right: 0;
            transition: background-color 0.3s ease;
            
            /* 完全参照 new_note_page.vue 的 note-render-area 样式 */
            background-color: var(--note-bg);
            border-radius: 12px;
            box-shadow: inset 0 0 0 1px var(--note-border);
            padding: 15px 15px 24px;
            
            /* 优化滚动条样式 */
            &::-webkit-scrollbar {
                width: 8px;
            }

            &::-webkit-scrollbar-track {
                background: var(--scroll-track);
                border-radius: 4px;
            }

            &::-webkit-scrollbar-thumb {
                background: var(--scroll-thumb);
                border-radius: 4px;
                border: 2px solid transparent;
                background-clip: content-box;

                &:hover {
                    background: var(--scroll-thumb-hover);
                    background-clip: content-box;
                }
            }

            &::-webkit-scrollbar-corner {
                background: transparent;
            }

            /* Firefox 滚动条 */
            scrollbar-width: thin;
            scrollbar-color: var(--scroll-track) var(--scroll-track);
        }

        .share-right_tb {
            flex: 1;
            margin-left: 0;
        }

        .share-textbox {
            /* 完全参照 new_note_page.vue 的 textbox 样式 */
            font-size: 16px;
            margin-bottom: 1.5em;

            h5 {
                /* 完全参照 new_note_page.vue 的时间戳样式 */
                text-align: center;
                color: var(--text-light) !important;
                margin: 20px 0 5px;
                font-weight: normal;
                font-size: 14px;
            }

            .share-yuantext {
                /* 完全参照 new_note_page.vue 的 yuantext + markdown-content 样式 */
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
                line-height: 1.8;
                color: var(--main-text-color) !important;
                max-width: 900px;
                margin: 0 auto 15px;
                font-size: 16px;
                letter-spacing: 0.3px;

                /* 完整的 markdown-content 样式 */
                :deep(h1) {
                    font-size: 22px;
                    font-weight: 600;
                    margin: 1.2em 0 0.8em;
                    color: var(--h1-color) !important;
                    border-bottom: 2px solid var(--border-light);
                    padding-bottom: 0.3em;
                    position: relative;
                    
                    &::after {
                        content: '';
                        position: absolute;
                        left: 0;
                        bottom: -2px;
                        width: 80px;
                        height: 2px;
                        background: linear-gradient(90deg, var(--primary-color) 0%, var(--primary-light) 100%);
                    }
                }

                :deep(h2) {
                    font-size: 20px;
                    font-weight: 600;
                    margin: 1.2em 0 0.8em;
                    color: var(--h2-color) !important;
                    padding-bottom: 0.2em;
                    border-bottom: 1px solid var(--border-light);
                }

                :deep(h3) {
                    font-size: 18px;
                    font-weight: 500;
                    margin: 1.2em 0 0.7em;
                    color: var(--h3-color) !important;
                }

                :deep(h4) {
                    font-size: 16px;
                    font-weight: 500;
                    margin: 1.2em 0 0.6em;
                    color: var(--h4-color) !important;
                }

                :deep(p) {
                    margin: 1.3em 0;
                    line-height: 1.8;
                    color: var(--p-color) !important;
                }

                :deep(strong) {
                    color: var(--strong-color) !important;
                    font-weight: 600;
                }

                :deep(em) {
                    color: var(--em-color) !important;
                }

                :deep(ul),
                :deep(ol) {
                    padding-left: 1.8em;
                    margin: 1.2em 0;

                    li {
                        margin: 0.6em 0;
                        line-height: 1.6;
                        color: var(--li-color) !important;
                        padding-left: 0.5em;
                        
                        &::marker {
                            color: var(--primary-color);
                        }
                    }
                }

                :deep(blockquote) {
                    margin: 1.8em 0;
                    padding: 1em 1.2em;
                    border-left: 4px solid var(--primary-color);
                    background: var(--blockquote-bg) !important;
                    border-radius: 8px;
                    box-shadow: 0 2px 8px var(--shadow-color);
                    position: relative;
                    overflow: hidden;

                    &::before {
                        content: '"';
                        position: absolute;
                        top: -10px;
                        left: 10px;
                        font-size: 5em;
                        color: var(--primary-light);
                        font-family: serif;
                        line-height: 1;
                    }

                    p {
                        margin: 0.5em 0;
                        color: var(--blockquote-text) !important;
                        position: relative;
                        font-style: italic;
                    }
                }

                :deep(code) {
                    font-family: 'JetBrains Mono', 'Fira Code', monospace;
                    background: var(--code-bg-enhanced) !important;
                    padding: 0.2em 0.4em;
                    border-radius: 4px;
                    font-size: 16px;
                    color: var(--code-color) !important;
                    font-weight: 500;
                    letter-spacing: -0.3px;
                }

                :deep(pre) {
                    background: var(--pre-bg-enhanced) !important;
                    padding: 1.4em;
                    border-radius: 12px;
                    overflow-x: auto;
                    margin: 1.8em 0;
                    border: 1px solid var(--border-light);
                    box-shadow: 0 3px 15px var(--shadow-color);
                    position: relative;

                    &::before {
                        content: attr(data-language);
                        position: absolute;
                        top: 0;
                        right: 0;
                        background: var(--primary-light);
                        padding: 0.3em 0.8em;
                        font-size: 16px;
                        color: var(--primary-color);
                        border-radius: 0 12px 0 6px;
                        text-transform: uppercase;
                        font-weight: 500;
                    }

                    code {
                        background: none !important;
                        padding: 0;
                        font-size: 16px;
                        color: var(--pre-text) !important;
                        text-shadow: none;
                        white-space: pre;
                        word-spacing: normal;
                        word-break: normal;
                        tab-size: 4;
                        hyphens: none;
                        font-weight: 400;
                        letter-spacing: normal;
                    }
                }

                :deep(table) {
                    width: 100%;
                    border-collapse: separate;
                    border-spacing: 0;
                    margin: 1.5em 0;
                    border-radius: 12px;
                    overflow: hidden;
                    box-shadow: 0 2px 15px var(--shadow-color);
                    background: var(--table-bg) !important;
                    font-size: 16px;
                    line-height: 1.6;

                    th,
                    td {
                        border: none;
                        border-bottom: 1px solid var(--border-light);
                        padding: 14px 18px;
                        text-align: left;
                        position: relative;
                    }

                    th {
                        background: var(--th-bg-enhanced) !important;
                        font-weight: 600;
                        color: var(--th-color) !important;
                        font-size: 16px;
                        text-transform: capitalize;
                        border-bottom: 2px solid var(--primary-light);
                        position: sticky;
                        top: 0;
                        z-index: 2;
                    }
                    
                    thead tr {
                        border-bottom: 2px solid var(--primary-light);
                    }

                    tbody tr {
                        transition: all 0.2s ease;
                        
                        &:hover {
                            background-color: var(--row-hover) !important;
                        }
                        
                        &:last-child td {
                            border-bottom: none;
                        }
                    }

                    tr:nth-child(even) {
                        background: var(--row-even) !important;
                    }
                    
                    td {
                        color: var(--td-color) !important;
                    }
                    
                    /* 添加列分隔线，但不添加到最后一列 */
                    td:not(:last-child)::after {
                        content: '';
                        position: absolute;
                        right: 0;
                        top: 25%;
                        height: 50%;
                        width: 1px;
                        background: var(--border-light);
                    }
                }

                :deep(hr) {
                    border: none;
                    height: 1px;
                    background: var(--border-light);
                    margin: 2em 0;
                }

                :deep(img) {
                    max-width: 100%;
                    border-radius: 8px;
                    margin: 1.5em 0;
                    box-shadow: 0 4px 12px var(--shadow-color);
                }

                :deep(a) {
                    color: var(--link-color) !important;
                    text-decoration: none;
                    border-bottom: 1px solid var(--link-border);
                    transition: all 0.3s ease;

                    &:hover {
                        border-bottom-color: var(--link-color);
                    }
                }

                // 任务列表样式
                :deep(input[type="checkbox"]) {
                    margin-right: 0.5em;
                    cursor: pointer;
                }
            }
        }
    }

    .share-youtubebox {
        margin-left: 2vw;
        margin-bottom: 20px;
    }

    /* 为分享页面添加优化的滚动条样式 */
    .share-markdown-content::-webkit-scrollbar,
    .share-markdown-content-noh::-webkit-scrollbar {
        width: 8px;
    }

    .share-markdown-content::-webkit-scrollbar-track,
    .share-markdown-content-noh::-webkit-scrollbar-track {
        background: var(--scroll-track);
        border-radius: 4px;
    }

    .share-markdown-content::-webkit-scrollbar-thumb,
    .share-markdown-content-noh::-webkit-scrollbar-thumb {
        background: var(--scroll-thumb);
        border-radius: 4px;
        border: 2px solid transparent;
        background-clip: content-box;

        &:hover {
            background: var(--scroll-thumb-hover);
            background-clip: content-box;
        }
    }

    .share-markdown-content::-webkit-scrollbar-corner,
    .share-markdown-content-noh::-webkit-scrollbar-corner {
        background: transparent;
    }

    .share-markdown-content {
        /* 完全参照 new_note_page.vue 的样式 */
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        line-height: 1.8;
        color: var(--main-text-color) !important;
        max-width: 900px;
        margin: 0 auto;
        font-size: 16px;
        letter-spacing: 0.3px;
        
        /* 保持原有的分享页面特定样式 */
        page-break-inside: avoid;
        padding: 0 20px;
        max-height: calc(100vh - 170px);
        margin-top: 0px;
        transition: color 0.3s ease;
        overflow-y: auto;
        
        /* 添加与 note-render-area 相同的背景和边框 */
        background-color: var(--note-bg);
        border-radius: 12px;
        box-shadow: inset 0 0 0 1px var(--note-border);
        padding: 15px 20px 24px;

        /* Firefox 滚动条支持 */
        scrollbar-width: thin;
        scrollbar-color: var(--scroll-track) var(--scroll-track);

        :deep(h1) {
            font-size: 22px;
            font-weight: 600;
            margin: 1.2em 0 0.8em;
            color: var(--h1-color) !important;
            border-bottom: 2px solid var(--border-light);
            padding-bottom: 0.3em;
            position: relative;
            
            &::after {
                content: '';
                position: absolute;
                left: 0;
                bottom: -2px;
                width: 80px;
                height: 2px;
                background: linear-gradient(90deg, var(--primary-color) 0%, var(--primary-light) 100%);
            }
        }

        :deep(h2) {
            font-size: 20px;
            font-weight: 600;
            margin: 1.2em 0 0.8em;
            color: var(--h2-color) !important;
            padding-bottom: 0.2em;
            border-bottom: 1px solid var(--border-light);
        }

        :deep(h3) {
            font-size: 18px;
            font-weight: 500;
            margin: 1.2em 0 0.7em;
            color: var(--h3-color) !important;
        }

        :deep(h4) {
            font-size: 16px;
            font-weight: 500;
            margin: 1.2em 0 0.6em;
            color: var(--h4-color) !important;
        }

        :deep(p) {
            margin: 1.3em 0;
            line-height: 1.8;
            color: var(--p-color) !important;
        }

        :deep(strong) {
            color: var(--strong-color) !important;
            font-weight: 600;
        }

        :deep(em) {
            color: var(--em-color) !important;
        }

        :deep(ul),
        :deep(ol) {
            padding-left: 1.8em;
            margin: 1.2em 0;

            li {
                margin: 0.6em 0;
                line-height: 1.6;
                color: var(--li-color) !important;
                padding-left: 0.5em;
                
                &::marker {
                    color: var(--primary-color);
                }
            }
        }

        :deep(blockquote) {
            margin: 1.8em 0;
            padding: 1em 1.2em;
            border-left: 4px solid var(--primary-color);
            background: var(--blockquote-bg) !important;
            border-radius: 8px;
            box-shadow: 0 2px 8px var(--shadow-color);
            position: relative;
            overflow: hidden;

            &::before {
                content: '"';
                position: absolute;
                top: -10px;
                left: 10px;
                font-size: 5em;
                color: var(--primary-light);
                font-family: serif;
                line-height: 1;
            }

            p {
                margin: 0.5em 0;
                color: var(--blockquote-text) !important;
                position: relative;
                font-style: italic;
            }
        }

        :deep(code) {
            font-family: 'JetBrains Mono', 'Fira Code', monospace;
            background: var(--code-bg-enhanced) !important;
            padding: 0.2em 0.4em;
            border-radius: 4px;
            font-size: 16px;
            color: var(--code-color) !important;
            font-weight: 500;
            letter-spacing: -0.3px;
        }

        :deep(pre) {
            background: var(--pre-bg-enhanced) !important;
            padding: 1.4em;
            border-radius: 12px;
            overflow-x: auto;
            margin: 1.8em 0;
            border: 1px solid var(--border-light);
            box-shadow: 0 3px 15px var(--shadow-color);
            position: relative;

            &::before {
                content: attr(data-language);
                position: absolute;
                top: 0;
                right: 0;
                background: var(--primary-light);
                padding: 0.3em 0.8em;
                font-size: 16px;
                color: var(--primary-color);
                border-radius: 0 12px 0 6px;
                text-transform: uppercase;
                font-weight: 500;
            }

            code {
                background: none !important;
                padding: 0;
                font-size: 16px;
                color: var(--pre-text) !important;
                text-shadow: none;
                white-space: pre;
                word-spacing: normal;
                word-break: normal;
                tab-size: 4;
                hyphens: none;
                font-weight: 400;
                letter-spacing: normal;
            }
        }

        :deep(table) {
            width: 100%;
            border-collapse: separate;
            border-spacing: 0;
            margin: 1.5em 0;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 2px 15px var(--shadow-color);
            background: var(--table-bg) !important;
            font-size: 15px;
            line-height: 1.6;

            th,
            td {
                border: none;
                border-bottom: 1px solid var(--border-light);
                padding: 14px 18px;
                text-align: left;
                position: relative;
            }

            th {
                background: var(--th-bg-enhanced) !important;
                font-weight: 600;
                color: var(--th-color) !important;
                font-size: 15px;
                text-transform: capitalize;
                border-bottom: 2px solid var(--primary-light);
                position: sticky;
                top: 0;
                z-index: 2;
            }
            
            thead tr {
                border-bottom: 2px solid var(--primary-light);
            }

            tbody tr {
                transition: all 0.2s ease;
                
                &:hover {
                    background-color: var(--row-hover) !important;
                }
                
                &:last-child td {
                    border-bottom: none;
                }
            }

            tr:nth-child(even) {
                background: var(--row-even) !important;
            }
            
            td {
                color: var(--td-color) !important;
            }
            
            /* 添加列分隔线，但不添加到最后一列 */
            td:not(:last-child)::after {
                content: '';
                position: absolute;
                right: 0;
                top: 25%;
                height: 50%;
                width: 1px;
                background: var(--border-light);
            }
        }

        :deep(hr) {
            border: none;
            height: 1px;
            background: var(--border-light);
            margin: 2em 0;
        }

        :deep(img) {
            max-width: 100%;
            border-radius: 8px;
            margin: 1.5em 0;
            box-shadow: 0 4px 12px var(--shadow-color);
        }

        :deep(a) {
            color: var(--link-color) !important;
            text-decoration: none;
            border-bottom: 1px solid var(--link-border);
            transition: all 0.3s ease;

            &:hover {
                border-bottom-color: var(--link-color);
            }
        }

        // 任务列表样式
        :deep(input[type="checkbox"]) {
            margin-right: 0.5em;
            cursor: pointer;
        }

        // 代码块语言标识
        :deep(.language-label) {
            position: absolute;
            top: 0;
            right: 1em;
            background: var(--border-light);
            padding: 0.2em 0.6em;
            border-radius: 0 0 4px 4px;
            font-size: 0.8em;
            color: var(--text-light);
        }
    }

    .share-markdown-content-noh {
        /* 继承主要样式但去掉标题装饰 */
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        line-height: 1.8;
        color: var(--main-text-color) !important;
        max-width: 900px;
        margin: 0 auto;
        font-size: 16px;
        letter-spacing: 0.3px;
        page-break-inside: avoid;
        padding: 0 2vw;
        margin-top: 40px;
        transition: color 0.3s ease;
        overflow-y: auto;
        
        /* Firefox 滚动条支持 */
        scrollbar-width: thin;
        scrollbar-color: var(--scroll-track) var(--scroll-track);

        :deep(h1),
        :deep(h2),
        :deep(h3),
        :deep(h4),
        :deep(h5),
        :deep(h6) {
            font-size: 1em;
            margin: 0.5em 0;
            color: var(--text-light) !important;
            border: none;
            padding: 0;
        }

        // 保持其他样式与主要内容一致
        :deep(p) {
            margin: 1.3em 0;
            line-height: 1.8;
            color: var(--p-color) !important;
        }

        :deep(ul),
        :deep(ol) {
            padding-left: 1.8em;
            margin: 1.2em 0;

            li {
                margin: 0.6em 0;
                line-height: 1.6;
                color: var(--li-color) !important;
                padding-left: 0.5em;
            }
        }

        :deep(blockquote) {
            margin: 1.8em 0;
            padding: 1em 1.2em;
            border-left: 4px solid var(--primary-color);
            background: var(--blockquote-bg) !important;
            border-radius: 8px;
            box-shadow: 0 2px 8px var(--shadow-color);
            position: relative;
            overflow: hidden;

            p {
                margin: 0.5em 0;
                color: var(--blockquote-text) !important;
                position: relative;
                font-style: italic;
            }
        }

        :deep(code) {
            font-family: 'JetBrains Mono', 'Fira Code', monospace;
            background: var(--code-bg-enhanced) !important;
            padding: 0.2em 0.4em;
            border-radius: 4px;
            font-size: 0.9em;
            color: var(--code-color) !important;
            font-weight: 500;
            letter-spacing: -0.3px;
        }

        :deep(pre) {
            background: var(--pre-bg-enhanced) !important;
            padding: 1.4em;
            border-radius: 12px;
            overflow-x: auto;
            margin: 1.8em 0;
            border: 1px solid var(--border-light);
            box-shadow: 0 3px 15px var(--shadow-color);
            line-height: 1.45;

            code {
                background: none !important;
                padding: 0;
                font-size: 0.95em;
                color: var(--pre-text) !important;
                font-weight: 400;
                letter-spacing: normal;
            }
        }

        :deep(img) {
            max-width: 100%;
            border-radius: 8px;
            margin: 1.5em 0;
            box-shadow: 0 4px 12px var(--shadow-color);
        }

        :deep(a) {
            color: var(--link-color) !important;
            text-decoration: none;
            border-bottom: 1px solid var(--link-border);
            transition: all 0.3s ease;

            &:hover {
                border-bottom-color: var(--link-color);
            }
        }
    }

    /* 移动端样式 */
    @media (max-width: 768px) {
        .share-desktop-actions {
            display: none;
        }

        .share-mobile-action-buttons {
            display: flex !important;
            z-index: 9999 !important;
            position: fixed !important;
            top: 250px !important;
            /* 与transcript按钮位置保持一致 */
            right: 20px;
            gap: 10px;
        }

        .share-el-dropdown {
            display: none !important;
        }

        /* 修改整体容器高度 */
        .share-notes {
            max-height: none !important;
            /* 移除最大高度限制 */
            padding-bottom: 180px !important;
            /* 添加大量底部padding */
            height: auto !important;
            /* 自动高度 */
            overflow: visible !important;
            /* 允许内容溢出 */
        }
    }

    /* 为移动标题和操作按钮添加样式 */
    .share-note-header {
        display: none;
    }

    .share-mobile-title {
        display: none;
    }

    .share-mobile-actions {
        display: none;
    }

    .share-mobile-action-buttons {
        display: none;
        position: absolute;
        top: 0;
        right: 20px;
        gap: 10px;
        z-index: 100;
    }

    .share-mobile-action-btn {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        background-color: var(--primary-color);
        color: white;
        border: none;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        transition: all 0.3s;
        box-shadow: 0 2px 8px var(--shadow-color);

        &:hover,
        &:active {
            transform: scale(1.05);
            background-color: var(--primary-hover);
        }

        &.share-copied {
            background-color: #34c759;
            animation: share-pulse 0.8s;
        }

        i {
            font-size: 20px;
        }
    }

    @keyframes share-pulse {
        0% {
            transform: scale(1);
        }

        50% {
            transform: scale(1.2);
        }

        100% {
            transform: scale(1);
        }
    }

    /* 将下载按钮隐藏在移动端 */
    @media (max-width: 768px) {
        .share-el-icon-download,
        [command="downloadaspdf"],
        [command="downloadaspdf-rr"],
        [command="downloadaspdf-lr"] {
            display: none !important;
        }
    }

    /* 添加复制成功的效果 */
    .share-copySuccessEffect {
        color: #34c759 !important;
        animation: share-pulse 0.8s;
    }

    /* 移动端YouTube样式优化 */
    @media (max-width: 768px) {
        .share-youtubebox {
            margin-left: 0;
            margin-right: 0;
            width: 100%;
            display: flex;
            justify-content: center;
        }
    }
}

/* 滚动条优化样式 */
.share-markdown-content,
.share-left_text {
    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-track {
        background: var(--scroll-track);
        border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
        background: var(--scroll-thumb);
        border-radius: 4px;
        border: 2px solid transparent;
        background-clip: content-box;

        &:hover {
            background: var(--scroll-thumb-hover);
            background-clip: content-box;
        }
    }
}

/* 添加媒体查询以在移动设备上调整Copy as按钮样式 */
@media (max-width: 768px) {
    .share-notes {
        .share-export {
            font-size: 14px !important;
            padding: 6px 12px !important;
            border-radius: 8px;
            right: 0px;
            top: 0px;
        }

        .share-copyasbox {
            padding: 0 10px;

            .share-left,
            .share-right {
                font-size: 18px;

                div {
                    margin-left: 15px;
                }
            }

            .share-copyas {
                padding: 5px 8px;
                font-size: 14px;
                border-radius: 8px;
                margin-right: 5px;
                border-width: 2px;
                color: var(--text-light);
            }
        }

        .el-dropdown-link {
            font-size: 16px !important;
        }

        /* 增大下拉菜单文字大小 */
        /deep/ .el-dropdown-menu__item {
            font-size: 16px !important;
            line-height: 1.5 !important;
            padding: 10px 15px !important;
        }

        /deep/ .el-dropdown-menu__item i {
            margin-right: 10px !important;
            font-size: 18px !important;
        }

        /* 为移动端的markdown内容添加底部边距 */
        .share-markdown-content {
            padding-bottom: 180px !important;
            /* 进一步增加底部边距 */
            max-height: none !important;
            /* 移除最大高度限制 */
            margin-bottom: 180px !important;
            /* 额外的底部边距 */
            -webkit-overflow-scrolling: touch;
        }

        /* 为移动端的transcript内容添加底部边距 */
        .share-alltextbox {
            padding-bottom: 180px !important;
            /* 增加底部边距 */
            margin-bottom: 180px !important;
            /* 额外的底部边距 */

            .share-left_text {
                height: auto !important;
                /* 自动高度 */
                max-height: none !important;
                /* 移除最大高度限制 */
                padding-bottom: 180px !important;
                /* 增加底部边距 */
            }
        }
    }
}
</style>